import React, { useEffect, useState } from "react";
import {
  FaUser,
  FaCalendarAlt,
  FaUmbrellaBeach,
  FaSuitcaseRolling,
} from "react-icons/fa";
import { getData } from "../../services/FetchNodeservices";

export default function EmployeeLeaveBalance() {
  const user = JSON.parse(localStorage.getItem("USER"));
  const [balance, setBalance] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user?.id) return;

    const fetchBalance = async () => {
      const res = await getData(`leave/balance/${user.id}`);
      if (res?.status) setBalance(res.data);
      setLoading(false);
    };

    fetchBalance();
  }, [user]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64 text-gray-500">
        Loading leave balance...
      </div>
    );
  }

  return (
    <>
    <div className="mt-6 p-6 max-w-3xl mx-auto">
      {/* Header */}
      <div className="bg-white rounded-xl shadow border p-6 mb-6">
        <div className="flex items-center gap-3">
          <FaUser className="text-blue-600" size={22} />
          <div>
            <h2 className="text-lg font-bold text-gray-800">
              {user.first_name} {user.last_name}
            </h2>
            <p className="text-sm text-gray-500">
              Employee Code: {user.employee_code}
            </p>
          </div>
        </div>
      </div>

      {/* Leave Balance Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        {/* Casual Leave */}
        <div className="bg-gradient-to-br from-blue-500 to-blue-600 text-white rounded-xl p-6 shadow-lg">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm opacity-90">Casual Leave (CL)</p>
              <h3 className="text-3xl font-bold mt-1">
                {balance?.casual_leave ?? 0}
              </h3>
              <p className="text-xs opacity-80 mt-1">Days Remaining</p>
            </div>
            <FaUmbrellaBeach size={36} className="opacity-80" />
          </div>
        </div>

        {/* Privilege Leave */}
        <div className="bg-gradient-to-br from-green-500 to-green-600 text-white rounded-xl p-6 shadow-lg">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm opacity-90">Privilege Leave (PL)</p>
              <h3 className="text-3xl font-bold mt-1">
                {balance?.annual_leave ?? 0}
              </h3>
              <p className="text-xs opacity-80 mt-1">Days Remaining</p>
            </div>
            <FaSuitcaseRolling size={36} className="opacity-80" />
          </div>
        </div>
      </div>

      {/* Info */}
      <div className="mt-6 bg-yellow-50 border border-yellow-200 rounded-lg p-4 text-sm text-yellow-800 flex gap-2 items-start">
        <FaCalendarAlt className="mt-1" />
        <p>
          Leave balance is updated automatically after admin approval.  
          Casual Leave resets yearly, Privilege Leave is carried forward as per company policy.
        </p>
      </div>
    </div>
    </>
  );
}
